'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _NotificationActions = require('../actions/NotificationActions');

var _AlertConstants = require('UIComponents/alert/AlertConstants');

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var defaultId = 0;
var timeouts = {};

exports.default = function (store) {
  return function (next) {
    return function (action) {
      var dispatch = store.dispatch;

      var result = next(action);

      if (!action.meta) {
        return result;
      }

      if (action.meta.removeNotification && action.meta.removeNotification.id) {
        dispatch((0, _NotificationActions.removeNotification)(action.meta.removeNotification.id));
      }

      if (!action.meta.notification) {
        return result;
      }

      var _action$meta$notifica = action.meta.notification,
          id = _action$meta$notifica.id,
          timeout = _action$meta$notifica.timeout,
          message = _action$meta$notifica.message,
          titleText = _action$meta$notifica.titleText,
          type = _action$meta$notifica.type,
          sticky = _action$meta$notifica.sticky,
          rest = _objectWithoutProperties(_action$meta$notifica, ['id', 'timeout', 'message', 'titleText', 'type', 'sticky']);

      var notificationId = id || 'ReduxMessenger-' + defaultId++;
      var notification = _extends({}, rest, {
        id: notificationId,
        message: message,
        sticky: !!sticky,
        timeout: timeout != null ? timeout : _AlertConstants.FLOATING_ALERT_DEFAULT_TIMEOUT,
        timestamp: Date.now(),
        titleText: titleText,
        type: type
      });

      if (!sticky && type !== 'danger') {
        // clear any existing timeouts. If another alert is being
        // created for the same id, the timeout should be reset.
        clearTimeout(timeouts[notificationId]);
        timeouts[notificationId] = setTimeout(function () {
          dispatch((0, _NotificationActions.removeNotification)(notification.id));
        }, notification.timeout);
      }

      dispatch((0, _NotificationActions.postNotification)(notification));
      return result;
    };
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ReduxMessenger/static-2.1985/js/middleware/NotificationMiddleware.js
// module id = 1267
// module chunks = 3